import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { InboundPatientRecord } from '../types/inbound-patient-record';
import { HsApiService } from './hs-api.service';
import { LogService } from './log.service';
import { LogoutService } from './logout.service';
import { RouterService } from './router.service';
import { SessionStorageService } from './session-storage.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject, interval, Observable, of } from 'rxjs';
import { flatMap, map, startWith, take, tap } from 'rxjs/operators';
import { SessionTimerService } from './session-timer.service';
import { TokenTimerService } from './token-timer.service';

@Injectable({
  providedIn: 'root'
})
export class InboundPatientService {
  private readonly intervalInMillis =
    environment.settings.session_timer.interval;
  private readonly refreshIntervalInMillis = environment.applications.inboundPatient.refreshTimer;

  private api = environment.api;

  private sessionIntervalWedge: number;
  private facilitiesList: any[] = [];

  isRefreshing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private log: LogService,
    private storageService: SessionStorageService,
    private sessionTimerService: SessionTimerService,
    private tokenTimerService: TokenTimerService,
    private logoutService: LogoutService,
    private router: RouterService,
    private hsApiService: HsApiService,
    private http: HttpClient
  ) {
  }

  keepSessionOpen() {
    if (!this.sessionIntervalWedge) {
      this.sessionIntervalWedge = window.setInterval(() => {
        this.log.trace('extend session');
        this.sessionTimerService.resetIdleCountdown();
        this.tokenTimerService.restart();
        this.sessionTimerService.restart();
      }, this.intervalInMillis);
    }
  }

  revertToGlobalSessionTimer(forceLogout: boolean = false) {
    if (this.sessionIntervalWedge) {
      window.clearTimeout(this.sessionIntervalWedge);
      this.sessionIntervalWedge = -1;
    }
    if (forceLogout) {
      this.logoutService.logout(() => {
      window.sessionStorage.clear();
      this.router.gotoLogin();
      setTimeout(() => window.location.reload());
    });
    }
  }

  getUserFacilitiesList()  {
    this.hsApiService.getFacilities().pipe(take(1)).subscribe(data => {
      this.facilitiesList.forEach(
        (facility) => facility.FacilityName = (data.find(fac => fac.FacilityCode === facility.FacilityCode) || {})['FacilityName'] || ''
      );
    });
    this.facilitiesList = (this.storageService.getUser().securityGroups || []).filter(
      (group) => group.startsWith('facility-')
    ).map(
      (facility) => ({
        FacilityCode: facility.replace('facility-', ''),
        FacilityName: facility.replace('facility-', '')
      })
    );
    return this.facilitiesList;
  }

  getInboundPatients(facilityId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Basic ${btoa(`${environment.applications
        .inboundPatient.auth.username
      }:${environment.applications
        .inboundPatient.auth.password}`)
      }`
    });
    const url = this.getUrl(this.api.inboundPatientList, {
      // uuxSessionId: this.storageService.getUUXSessionId(),
      // apiServer: 'accessapi-stage.manifestmedex.org',
      FacilityId: facilityId
    });
    this.log.trace('InboundPatientService.getInboundPatients.url', url);

    // return interval(this.refreshIntervalInMillis).pipe(
    //   startWith(0),
    //   flatMap(() => new Observable(
    //     (obs) => {
    //       obs.next({data: [
    //         {
    //           'Name': { 'FamilyName': 'GUREVICH', 'GivenName': 'MALINDA' },
    //           'PatientId': '494537TEST9',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'F',
    //           'BirthDate': '19090523',
    //           'ChiefComplaint': '',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'f39885e40f2b4079980df8c5437019ce',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': 'TEST1', 'GivenName': 'TEST' },
    //           'PatientId': '494537',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'F',
    //           'BirthDate': '19981108',
    //           'ChiefComplaint': '',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'f39885e40f2b4079980df8c5437019ce',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': 'APPLE', 'GivenName': 'KATE' },
    //           'PatientId': '494537',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'M',
    //           'BirthDate': '19900708',
    //           'ChiefComplaint': '',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'f39885e40f2b4079980df8c5437019ce',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': 'TEST1', 'GivenName': 'TEST2' },
    //           'PatientId': '494511',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'M',
    //           'BirthDate': '19470310',
    //           'ChiefComplaint': '',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'e6c5213be7384613b377ed2f236236f2',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': 'TEST1', 'GivenName': 'TEST2' },
    //           'PatientId': '494511',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'M',
    //           'BirthDate': '19470310',
    //           'ChiefComplaint': '',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'e6c5213be7384613b377ed2f236236f2',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': 'TEST1', 'GivenName': 'TEST2' },
    //           'PatientId': '494511',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'M',
    //           'BirthDate': '19470310',
    //           'ChiefComplaint': '',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'e6c5213be7384613b377ed2f236236f2',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': 'APPLE', 'GivenName': 'KATE' },
    //           'PatientId': '494537',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'M',
    //           'BirthDate': '19900708',
    //           'ChiefComplaint': '',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'f39885e40f2b4079980df8c5437019ce',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': 'AYSTER', 'GivenName': 'DIANA' },
    //           'PatientId': '494545',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'F',
    //           'BirthDate': '19450310',
    //           'ChiefComplaint': 'Opioid abuse with opioid-induced psychotic disorder with hallucinations',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'e6c5213be7384613b377ed2f236236f2',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': 'AYSTER', 'GivenName': 'DIANA' },
    //           'PatientId': '',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'F',
    //           'BirthDate': '19450310',
    //           'ChiefComplaint': 'Opioid abuse with opioid-induced psychotic disorder with hallucinations',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'e6c5213be7384613b377ed2f236236f2',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': 'AYSTER', 'GivenName': 'DIANA' },
    //           'PatientId': '',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'F',
    //           'BirthDate': '19450310',
    //           'ChiefComplaint': 'Opioid abuse with opioid-induced psychotic disorder with hallucinations',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'e6c5213be7384613b377ed2f236236f2',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': 'TESTxyz', 'GivenName': 'TESTJane' },
    //           'PatientId': '',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'F',
    //           'BirthDate': '19900102',
    //           'ChiefComplaint': 'Opioid abuse',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'e7220494d45d465f8696ab6d85d79c8a',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': '', 'GivenName': '' },
    //           'PatientId': '',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': '',
    //           'BirthDate': '',
    //           'ChiefComplaint': '',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': '',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': '', 'GivenName': '' },
    //           'PatientId': '',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': '',
    //           'BirthDate': '',
    //           'ChiefComplaint': '',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': '',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': 'TESTxyz', 'GivenName': 'TESTJane' },
    //           'PatientId': '',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'F',
    //           'BirthDate': '19900102',
    //           'ChiefComplaint': 'Opioid abuse',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'e7220494d45d465f8696ab6d85d79c8a',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         },
    //         {
    //           'Name': { 'FamilyName': 'TESTxyz', 'GivenName': 'TESTJane' },
    //           'PatientId': '',
    //           'PrimaryLanguage': '',
    //           'MaritalStatus': '',
    //           'Gender': 'F',
    //           'BirthDate': '19900102',
    //           'ChiefComplaint': 'Opioid abuse',
    //           'Destination': 'PCH',
    //           'ETA': '1',
    //           'RadioNumber': 'e7220494d45d465f8696ab6d85d79c8a',
    //           'AlertReceivedDateTime': '2020-11-25 13:00:00',
    //           'AlertProcessedDateTime': ''
    //         }
    //       ].map( pr => new InboundPatientRecord(pr)), message: false });
    //     })
    //   )
    // );

    return interval(this.refreshIntervalInMillis).pipe(
      startWith(0),
      tap(() => this.isRefreshing.next(true) ),
      flatMap(() => this.http.get<any>(url, { headers: headers }).pipe(
        map(response => {
          this.log.trace('InboundPatientService.getInboundPatients.response', response);
          if (response.Error) {
            return {
              data: [],
              message: `${((response || {}).Error || '').substr(0, 50)}...`
            };
          }
          return {
            data: (((response || {}).PatientObjects || {}).Patient || []).map(pr => new InboundPatientRecord(pr)),
            message: false
          };
        })
      )),
      tap(() => this.isRefreshing.next(false) )
    );
  }

  acknowledgeAlert(facilityId: string, patientId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Basic ${btoa(`${environment.applications
        .inboundPatient.auth.username
      }:${environment.applications
        .inboundPatient.auth.password}`)
      }`
    });
    const url = this.getUrl(this.api.inboundPatientAcknowledgeAlert);
    this.log.trace('InboundPatientService.inboundPatientAcknowledgeAlert.url', url);
    return this.http.post<any>(url, {
      // uuxSessionId: this.storageService.getUUXSessionId(),
      FacilityId: facilityId,
      PatientId: patientId
    }, { headers: headers }).pipe(
      map((response) => response.Result === 0)
    );
  }

  getUrl(baseUrl: string, params?: any) {
    if (!params) {
      return baseUrl;
    }
    else {
      return baseUrl + '?' + this.encodeData(params);
    }
  }

  loggedInUserHasOtherRoles(): boolean {
    const user = this.storageService.getUser();
    return user.securityGroups.filter(group => _.startsWith(group, 'app-')).length > 1;
  }

  private encodeData(data: any): string {
    return Object.keys(data)
      .map(key => {
        return [key, data[key]].map(encodeURIComponent).join('=');
      })
      .join('&');
  }
}
